module.exports = __webpack_public_path__ + "static/media/oval-button.44069779.png";